import React from 'react';
import { FetchBranchResult } from '../types';
import styled from 'styled-components';
import { FaxIcon, PhoneIcon, EnvelopeIcon, MapmarkerIcon } from './Icons';
import { Link } from '@wco/toolkit';
import css from '@styled-system/css';
import appConfig from '../config';

const AddressDetails = styled.ul`
  margin-bottom: ${props => props.theme.space.small};
  margin-top: 0px;
  padding: 0px;
  li {
    display: block;
  }
`;

const ContactListUL = styled.ul`
  padding: 0px;
`;

const ContactList = styled.li`
  padding-left: ${props => props.theme.space.large};
  position: relative;
  margin: 0;
  font-size: ${props => props.theme.fontSizes.text.medium};
  display: block;
  float: none;
`;

const DesktopView = styled.span`
  ${css({
    display: ['none', 'block']
  })}
`;

const MobileView = styled.span`
  ${css({
    display: ['block', 'none']
  })}
`;

export default function Address(props: FetchBranchResult) {
  return (
    <AddressDetails data-testid="address-container">
      <li>
        <ContactListUL>
          <ContactList>
            <MapmarkerIcon />
            <Link
              target="_blank"
              rel="noopener noreferrer"
              href={encodeURI(
                `https://www.google.com/maps/dir/?api=1&destination=${props.address} ${props.city}`
              )}
            >
              {props.address} <br /> {props.postalCode} {props.city}
            </Link>
          </ContactList>
          <ContactList>
            <PhoneIcon />
            <DesktopView>{props.telephone}</DesktopView>
            <MobileView>
              <Link
                href={
                  props.telephone
                    ? `tel:+45${props.telephone.replace(/\s/g, '')}`
                    : ''
                }
              >
                {props.telephone}
              </Link>
            </MobileView>
          </ContactList>
          {appConfig.showFax && (
            <ContactList>
              <FaxIcon />
              <span>{props.fax}</span>
            </ContactList>
          )}
          <ContactList>
            <EnvelopeIcon />
            <Link href={'mailto:' + props.email}>{props.email}</Link>
          </ContactList>
        </ContactListUL>
      </li>
    </AddressDetails>
  );
}
